<template>
  <div
    class="footer"
    v-if="shouldDisplay"
  >
    <div class="footer-top">
      <logo logoType="grey"/>
    </div>
    <div class="footer-bottom">
      <copyright class="copyright"/>
      <div class="links">
        <div v-for="link in footerLinks" :key="link.title" class="footer-link">
          <a :href="link.href">
            {{ $t(`ui.footer.${link.title}`) }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from '@/components/layouts/partials/Logo'
import Copyright from '@/components/layouts/partials/Copyright'

export default {
  components: {
    Logo,
    Copyright
  },
  computed: {
    footerLinksHref() {
      return this.$store.getters.getFooterLinks
    },
    shouldDisplay() {
      return this.$store.getters.getFooterDisplay
    },
    footerLinks() {
      return [
        {
          href: this.footerLinksHref.imprint,
          title: 'imprint'
        },
        {
          href: this.footerLinksHref.privacy,
          title: 'privacy'
        },
        {
          href: this.footerLinksHref.terms,
          title: 'terms'
        },
      ]
    }
  }
}
</script>
<style lang="scss">
.footer {
  display: flex;
  padding: 10px 0 20px;
  flex-direction: column;
  margin-top: auto;
}

.footer-top {
  margin: auto;
  margin-bottom: 25px;
}

.footer-bottom {
  display: flex;
  margin: auto;
  color: $ink-lighter;
  font-size: 15px;
  flex-direction: row;
}

.copyright {
  margin-right: 15px;
  white-space: nowrap;
  font-size: 12px;
  vertical-align: sub;
}

.footer-link {
  padding: 0 7px;
  border-right: 1px solid #b0b0b0;
  a {
    color: $ink-lighter;
    font-size: 12px;
    transition: all .15s ease-out;
    font-weight: $font-medium;
  }
  a:hover {
    color: $ink;
    }
}

.footer-link:last-child {
  border-right: 0px solid #b0b0b0;
}

.links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}


@media only screen and (max-width: 700px) {
  .copyright {
    text-align: center;
    margin-bottom: 3px;
  }

  .footer-bottom {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// AppFooter.vue?4d51b784